export const requestOtp = async (email) => {
    try {
        const res = await fetch('/api/user-login', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email }),
        });
        return await res.json();
    } catch {
        return { message: 'Request failed. Please try again.' };
    }
};

export const verifyOtp = async (email, otp) => {
    try {
        const res = await fetch('/api/user-login', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email, otp }),
        });
        return await res.json();
    } catch {
        return { message: 'Verification failed. Please try again.' };
    }
};

export const googleLogin = async (credential) => {
    try {
        const res = await fetch('/api/user-login/google', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ credential }),
        });
        return await res.json();
    } catch {
        return { message: 'Google sign-in failed. Please try again.' };
    }
};
